import { NotificationRoot } from './pages/notification-center-root'

import type { RouteObject } from 'react-router-dom'

const notificationsRoutes: RouteObject[] = [
  {
    path: 'notifications',
    element: <NotificationRoot />,
  },
]

export { notificationsRoutes }
